import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import PostLogin from '../../layout/postLogin'
import Question1 from './components/question1'
import CopyQuestion from './components/copyQuestion'
import { NAME_QUESTION_MANAGEMENT, CONST_QUESTION_MANAGEMENT_DETAILS } from '../../constants'
import { Wrapper } from './style'

const QuestionManagement = () => {
  const [questionDetails, setQuestionDetails] = useState(null)
  const search = useLocation().search
  const type = new URLSearchParams(search).get('type') || CONST_QUESTION_MANAGEMENT_DETAILS[0].type

  useEffect(() => {
    const questionList = CONST_QUESTION_MANAGEMENT_DETAILS.find(f => f.type === type) || null
    setQuestionDetails(questionList)
  }, [type, search])

  useEffect(() => {
    document.title = NAME_QUESTION_MANAGEMENT
  }, [])

  return (
    <PostLogin pageTitle={NAME_QUESTION_MANAGEMENT}>
      {questionDetails && <Wrapper>
        {questionDetails.type === 'copyQuestion'
          ? <CopyQuestion settings={questionDetails} />
          : <Question1 settings={questionDetails} />}
      </Wrapper>}
    </PostLogin>
  )
}

export default QuestionManagement
